<template>
  <div class="button-footer">
  <!-- Secondary button -->
    <!-- External website link -->
    <button
      v-if="instructions.alternateNextStep && instructions.alternateNextStep.link"
      :name="`${instructions.currentStep}_altContinueButton`"
      :id="`${instructions.currentStep}_altContinueButton`"
      :class="isIntro ? `display-page__button-secondary` : `button-secondary`"      
      v-on:click="onLinkTap(instructions.alternateNextStep.link)"
    >{{ instructions.alternateNextStep.titleTx ? $t(instructions.alternateNextStep.titleTx) : instructions.alternateNextStep.title }}</button>
    <!-- Internal routing -->
    <router-link 
      v-else-if="instructions.alternateNextStep &&
        instructions.alternateNextStep.externalLink"
      tag="button"
      class="button-secondary"
      style="margin-bottom: 10px"
      :to=instructions.alternateNextStep.externalLink>Visit Yahoo.com
    </router-link>

    <router-link
      v-else-if="instructions.alternateNextStep"
      tag="button"
      class="button-secondary"
      style="margin-bottom: 10px"
      :to="{
        name: instructions.alternateNextStep.nextStepName,
        params: {
          brand: $route.params.brand,
          device: $route.params.device,
          step: instructions.alternateNextStep.nextStep,
        },
        query: {
          lastStep: instructions.alternateNextStep.lastStep,
          mode: $route.query.mode || 'light'
        }
      }"
      :name="`${instructions.currentStep}_altContinueButton`"
      :id="`${instructions.currentStep}_altContinueButton`"
    >{{ instructions.alternateNextStep.titleTx ? $t(instructions.alternateNextStep.titleTx) : instructions.alternateNextStep.title }}</router-link>

  <!-- Primary button -->
    <!--
      this link to an external resource serves only to reload our
      app WebView letting us know that the instruction flow has ended
    -->
    <a
      v-if="instructions.isLastPage"
      :href="instructions.lastPageExitUrl"
      v-on:click="onPrimaryBtnTap(instructions.primaryActionKey)"
    >
      <button
        class="button-primary"
        :name="`${instructions.currentStep}_lastPageContinueButton`"
        :id="`${instructions.currentStep}_lastPageContinueButton`"
      >{{ instructions.continueButtonTx ? $t(instructions.continueButtonTx) : (instructions.continueButtonText || $t('common.getStarted')) }}</button>
    </a>
    <!-- Internal routing -->
    <router-link
      v-if="!instructions.isLastPage && instructions.nextStep"
      :class="isIntro ? 'display-page__button-primary' : 'button-primary'"
      tag="button"
      :to="{
        name: instructions.nextStepName,
        params: {
          brand: $route.params.brand,
          device: $route.params.device,
          step: instructions.nextStep,
        },
        query: {
          mode: $route.query.mode || 'light'
        },
      }"
      :name="`${instructions.currentStep}_continueButton`"
      :id="`${instructions.currentStep}_continueButton`"
    >{{ instructions.continueButtonTx ? $t(instructions.continueButtonTx) : (instructions.continueButtonText || $t('common.continue')) }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'ButtonFooter',
  props: {
    isIntro: {
      type: Boolean,
      default: false,
    },
    instructions: {
      type: Object,
      required: true,
    }
  },
  methods: {
    onPrimaryBtnTap(primaryActionKey) {
      const oWebViewInterface = window.nsWebViewInterface;
      // emit event to native app
      oWebViewInterface && oWebViewInterface.emit('primaryBtnTap', primaryActionKey);
      window.ReactNativeWebView && window.ReactNativeWebView.postMessage(
        JSON.stringify({ primaryBtnTap: primaryActionKey })
      );
    },
    onLinkTap(link) {
      const oWebViewInterface = window.nsWebViewInterface;
      // emit event to native app
      oWebViewInterface && oWebViewInterface.emit('linkTapped', link);
      window.ReactNativeWebView && window.ReactNativeWebView.postMessage(
        JSON.stringify({ linkTapped: link })
      );
    },
  },
}
</script>
